import { create } from 'zustand';
import type { NavigateFunction } from 'react-router-dom';

/** Режим сборки заказа клиента: каталог → корзина менеджера → импорт в заказ CRM. */
export type OrderComposeTarget = {
  orderId: number;
  orderNumber: string;
};

type OrderComposeStore = {
  target: OrderComposeTarget | null;
  setTarget: (t: OrderComposeTarget) => void;
  clearTarget: () => void;
};

export const useOrderComposeStore = create<OrderComposeStore>((set) => ({
  target: null,
  setTarget: (t) => set({ target: t }),
  clearTarget: () => set({ target: null }),
}));

/** Каталог для сборки заказа: сначала навигация, потом закрытие drawer (WebView-safe). */
export function openOrderComposeCatalog(
  navigate: NavigateFunction,
  target: OrderComposeTarget,
  closeDeal?: () => void,
) {
  useOrderComposeStore.getState().setTarget(target);
  navigate('/catalog');
  window.setTimeout(() => closeDeal?.(), 0);
}
